import cx from "classnames";
import { forwardRef, HTMLProps, Ref } from "react";

import { FormControl } from "./form-control";

export const Input = forwardRef(
  (
    {
      id,
      label,
      error,
      required,
      className,
      inputClassName,
      labelClassName,
      hideLabel,
      requiredText,
      ...props
    }: {
      error?: string;
      hideLabel?: boolean;
      inputClassName?: string;
      labelClassName?: string;
      requiredText?: string;
    } & HTMLProps<HTMLInputElement>,
    ref: Ref<HTMLInputElement> | undefined
  ) => {
    const fieldId = id || props.name || "";
    return (
      <FormControl
        id={fieldId}
        error={error}
        label={label}
        className={className}
        hideLabel={hideLabel}
        required={required}
        requiredText={requiredText}
        labelClassName={labelClassName}
      >
        <div className="flex items-center">
          <input
            ref={ref}
            id={fieldId}
            required={required}
            className={cx(
              "disabled:bg-gray-300 mb-2 w-full overflow-hidden text-ellipsis whitespace-nowrap rounded-lg border border-solid border-gray-300 px-3 py-2 text-sm text-gray-800 focus:outline-blue-500 enabled:bg-white",
              {
                "ring-2 ring-red-500 focus:outline-none": !!error,
              },
              inputClassName
            )}
            {...props}
          />
        </div>
      </FormControl>
    );
  }
);

Input.displayName = "Input";
